import { createContext, useContext } from "react";

export const V2ModeContext = createContext(false);
export const useV2Mode = () => useContext(V2ModeContext);
